<template>
  <zl-saas-container>
    <!-- 操作记录 -->
    <operRecord :id="$route.query.id" isSupplier />
    <!-- 退换货基本信息 -->
    <thhInfo
      :isExchange="$route.query.type === 'exchange'"
    />
    <template slot="footer">
      <el-button type="primary" plain @click="goBack" size="small">
        返回
      </el-button>
      <template v-if="$route.query.hasBtn === 'sure'">
        <el-button size="small" @click="refuse">
          拒绝
        </el-button>
        <el-button type="primary" size="small" @click="submit">
          确认
        </el-button>
      </template>
    </template>
  </zl-saas-container>
</template>
<script>
import { mapActions } from 'vuex'
import thhInfo from '@/components/order/return/thhInfo.vue'
import refuseOrderDialog from '@/components/dialog/refuseOrderDialog.vue'
import operRecord from '@/components/business/operRecord.vue'
export default {
  name: 'SupplierReturnDetail',
  components: { thhInfo, operRecord },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    ...mapActions([
      'confirmTHHInfoGys'
    ]),
    goBack() {
      this.$router.back()
    },
    // 确认
    submit() {
      this.$confirm(`是否确认${this.isExchange ? '换货' : '退货'}完成`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          thhId: this.$route.query.id,
          flag: true
        }
        this.confirmTHHInfoGys(data).then(res => {
          this.$zl.message.success(`${this.isExchange ? '换货' : '退货'}成功`)
          this.$closeAndPush({
            name: 'SupplierReturnAndExchange',
            params: {
              isOperType: true
            }
          })
        })
      }).catch(() => {
      })
    },
    // 拒绝
    refuse() {
      this.$zl.dialog.openFull(refuseOrderDialog, {
      }).then(res => {
        const data = {
          thhId: this.$route.query.id,
          flag: false,
          reason: res
        }
        this.confirmTHHInfoGys(data).then(res => {
          this.$zl.message.success(`拒绝成功`)
          this.$closeAndPush({
            name: 'SupplierReturnAndExchange',
            params: {
              isOperType: true
            }
          })
        })
      })
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/order.scss';
</style>
